import makeApi from 'libs/core/configureAxios'

const api = makeApi(`${process.env.REACT_APP_API_BASE_URL}`)

const getPhishCampaigns = payload => api.get('/platform/admin/phish-camps/group', payload)

// 下拉選單用：後台清單查詢本身已不含寄送數、釣中率等統計子查詢，直接沿用同一支 API；
// 獨立成另一個 effect 是為了不寫入列表頁共用的 phishCampaignList
const getPhishCampaignOptions = ({ params }) =>
  api.get('/platform/admin/phish-camps/group', { params })

const getPhishCampaignChildren = payload =>
  api.get(`/platform/admin/phish-camps/children/${payload.campaignId}`, payload.params)

const getPhishCampaignsStatusTotal = payload => api.get('/platform/phish-camps/status', payload)

const getPhishCampaignDetails = payload =>
  api.get(`/platform/admin/phish-camps/group/${payload.campaignId}`, payload.params)

const getPhishCampaignChildDetails = payload =>
  api.get(`/platform/admin/phish-camps/${payload.campaignId}`, payload.params)

const getPhishCampaignUsers = payload =>
  api.get(`/platform/phish-camps/group/users/${payload.campaignId}`, payload)

const getPhishCampaignChildUsers = payload =>
  api.get(`/platform/phish-camps/users/${payload.campaignId}`, payload)

const sendPhishCampaignTest = payload =>
  api.post(`/platform/phish-camps/test-camp`, payload.data, { params: payload.params })

const createPhishCampaign = payload =>
  api.post(`/platform/phish-camps`, payload.data, { params: payload.params })

const updatePhishCampaign = payload =>
  api.put(`/platform/phish-camps/${payload.finalCampaignId}`, payload.data, {
    params: payload.params,
  })

const getPhishSmsCampaigns = payload => api.get('/platform/phish-camps/sms/group', payload)

const getPhishSmsCampaignChildren = payload =>
  api.get(`/platform/phish-camps/sms/children/${payload.campaignId}`, payload.params)

const getPhishSmsCampaignsStatusTotal = payload =>
  api.get('/platform/phish-camps/sms/status', payload)

const getPhishSmsCampaignDetails = payload =>
  api.get(`/platform/phish-camps/sms/group/${payload.campaignId}`, payload.params)

const getPhishSmsCampaignChildDetails = payload =>
  api.get(`/platform/phish-camps/sms/${payload.campaignId}`, payload.params)

const getPhishSmsCampaignUsers = payload =>
  api.get(`/platform/phish-camps/sms/group/users/${payload.campaignId}`, payload)

const getPhishSmsCampaignChildUsers = payload =>
  api.get(`/platform/phish-camps/sms/users/${payload.campaignId}`, payload)

const deletePhishCampaign = payload =>
  api.delete(`/platform/phish-camps/${payload.phishCampId}`, { params: payload.params })

const deletePhishCampaignMain = payload =>
  api.delete(`/platform/phish-camps/group/${payload.phishCampId}`, { params: payload.params })

export default {
  getPhishCampaigns,
  getPhishCampaignOptions,
  getPhishCampaignChildren,
  getPhishCampaignsStatusTotal,
  getPhishCampaignDetails,
  getPhishCampaignChildDetails,
  getPhishCampaignUsers,
  getPhishCampaignChildUsers,
  sendPhishCampaignTest,
  createPhishCampaign,
  updatePhishCampaign,
  getPhishSmsCampaigns,
  getPhishSmsCampaignChildren,
  getPhishSmsCampaignsStatusTotal,
  getPhishSmsCampaignDetails,
  getPhishSmsCampaignChildDetails,
  getPhishSmsCampaignUsers,
  getPhishSmsCampaignChildUsers,
  deletePhishCampaign,
  deletePhishCampaignMain,
}
